import { FilterFn } from '@tanstack/react-table';

declare module '@tanstack/table-core' {
  interface FilterFns {
    startsWithString: FilterFn<unknown>
  }
}

const startsWithString: FilterFn<any> = (
  row,
  columnId: string,
  filterValue: string
) => {
  const search = filterValue.toLowerCase()
  return Boolean(
    row
      .getValue<string | null>(columnId)
      ?.toString()
      ?.toLowerCase()
      ?.startsWith(search)
  )
};

export default startsWithString;
